import { render } from "./SupplierUpdate.vue?vue&type=template&id=4cef73c9&scoped=true"
import script from "./SupplierUpdate.vue?vue&type=script&lang=ts"
export * from "./SupplierUpdate.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4cef73c9"

export default script